<template>
  <div id="paginaTabellaRaccordoDestinatari">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Spreadsheet -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Tabella di Raccordo Destinatari</b-card-title>
              <b-card-text class="mb-0">Teatro Coccia</b-card-text>
            </div>
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
            <!-- Button:  -->
            <b-col xl="2" md="4" class="text-left mt-1">
              <ejs-button id="caricaButton" @click.native="buttonLoad()">Carica</ejs-button>
            </b-col>
            <b-col xl="2" md="4" class="text-left mt-1">
              <ejs-button id="salvaButton" @click.native="buttonSave()">Salva</ejs-button>
            </b-col>

            <b-col xl="12" md="12" class="text-left mt-1">
            <ejs-spreadsheet ref="spreadsheet" height=800 :created="created" :showRibbon="false" :showFormulaBar="false"
              :showSheetTabs="false" dataSource="sorgente">
            </ejs-spreadsheet>
          </b-col>
          </b-row>
          </b-card-body>
        </b-card>
      </b-col>



    </b-row>

  </div>
</template>
<script>
import Vue from "vue";
import useJwt from '@/auth/jwt/useJwt'
import { enableRipple } from '@syncfusion/ej2-base';
import { DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection } from "@syncfusion/ej2-vue-dropdowns";
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet';
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter } from '@syncfusion/ej2-vue-grids';
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

import { LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin } from 'bootstrap-vue'


Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(EmbedPlugin);
Vue.use(TablePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormSelectPlugin);

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(SliderPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
enableRipple(true);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(SpreadsheetPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(ListBoxPlugin);

const apiRaccordoUrl = "/demo/api/raccordo";

export default Vue.extend({
  data: function () {
    return {
      id: 0,
      data: [],
      sorgente: {},
    }
  },

  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    // per spreadsheet
    created: function () {
      // formatto la prima riga
      this.$refs.spreadsheet.cellFormat({
        fontWeight: 'bold',
        fontSize: '12pt',
        backgroundColor: '#99505f',
        textAlign: 'center',
        color: '#ffffff',
        borderBottom: '1px solid #e0e0e0'
      }, 'A1:AE1')
      // formatto le prime due colonne
      this.$refs.spreadsheet.cellFormat({
        fontWeight: 'bold',
        fontSize: '12pt',
        backgroundColor: '#FFF7CB',
        textAlign: 'center',
        color: '#000000',
        borderBottom: '1px solid #e0e0e0'
      }, 'A2:B300')
      // proteggere da scrittura la prima riga
      // let protectSetting = {
      //       selectCells: true,
      //       formatCells: false,
      //       formatRows: false,
      //       formatColumns: false,
      //       insertLink: false
      //   };
      // this.$refs.spreadsheet.protectSheet("Issues", protectSetting);
      // this.$refs.spreadsheet.lockCells('A1:AE1', true); // to lock the cells
      // this.$refs.spreadsheet.lockCells('A2:AE1000', false);
      // posizionare cursore in seconda riga prima colonna
      //this.$refs.spreadsheet.goTo("A2"); // pass the range
    },
    buttonLoad() {
      this.makeToast('primary', 'Info', 'Caricamento eseguito')
      this.$refs.spreadsheet.goTo("A3"); // pass the range
      // chiamare raccordo

      useJwt.get(apiRaccordoUrl).then((d) => {
        console.log(d.data);
        this.$refs.spreadsheet.openFromJson({file: d.data[0]['tabella']})

      });
    },
    buttonSave() {
      this.$refs.spreadsheet.saveAsJson().then(jsonData => {
       useJwt.post(apiRaccordoUrl, jsonData)
      }).then(data => console.log(data))
      this.makeToast('primary', 'Info', 'Salvataggio eseguito')
      // gestire feedback <---------TODO--------------------------
      // se riuscito, svuotare spreadsheet e posizionare cursore in seconda riga prima colonna <---------TODO--------------------------
      //this.$refs.spreadsheet.clear({type: 'Clear Contents', range: 'A2:Z10'}); // Clear the content in the provided range
      this.$refs.spreadsheet.goTo("A2"); // pass the range
    },


  }
});
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-navigations/styles/material.css';
@import '~@syncfusion/ej2-popups/styles/material.css';
</style>